import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import CustomDataTableEditable from "../../../../partials/content/CustomDataTableEditable";
import { getOutletMasterDataAPI } from "../../../../services/sales/outletService";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import {
  checkRegexEmail,
  checkRegexPhoneNumber,
} from "../../../../utils/utils";
function ConfirmUploadedOutlets() {
  const { values, handleSubmit } = useFormikContext();
  const [auth, setAuth] = useState({});
  const [countryOptions, setCountryOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [thermalPrinterSizeOptions, setThermalPrinterSizeOptions] = useState(
    []
  );

  useEffect(() => {
    function getOutletMasterData() {
      getOutletMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { currencies, countries } = data;
        setMasterData(currencies, countries);
        setAuth(auth);
      });
    }
    getOutletMasterData();
  }, []);
  return (
    <>
      {values.length > 0 ? (
        <CustomDataTableEditable
          data={values}
          buttons={[
            {
              name: "Upload",
              onClick: (e) => {
                handleSubmit(e);
              },
              icon: "fas fa-upload",
              color: "success",
            },
          ]}
          onRowEditComplete={(e) => {
            let { newData, index } = e;
            values[index] = newData;

            /*Update selected dropdown label*/
            const currencyCode = currencyOptions.filter(function(dropdown) {
              return dropdown.value === values[index].currencyID;
            });
            if (currencyCode.length > 0) {
              values[index].currencyCode = currencyCode[0].label;
            } else {
              values[index].currencyID = 0;
              values[index].currencyCode = "";
            }

            const thermalPrinterSizeName = thermalPrinterSizeOptions.filter(
              function(dropdown) {
                return dropdown.value === values[index].thermalPrinterSizeID;
              }
            );
            if (thermalPrinterSizeName.length > 0) {
              values[index].thermalPrinterSizeName =
                thermalPrinterSizeName[0].label;
            } else {
              values[index].thermalPrinterSizeID = 0;
              values[index].thermalPrinterSizeName = "";
            }

            const countryName = countryOptions.filter(function(dropdown) {
              return dropdown.value === values[index].countryCode;
            });
            if (countryName.length > 0) {
              values[index].countryName = countryName[0].label;
            } else {
              values[index].countryCode = "";
              values[index].countryName = "";
            }

            /*Update mass upload status ID*/
            values[index].statusID = 1;

            if (values[index].outletName === "") {
              values[index].statusID = 0;
            }
            if (values[index].addressPhone === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexPhoneNumber(values[index].addressPhone) !== true) {
                values[index].statusID = 0;
              }
            }
            if (values[index].addressEmail === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexEmail(values[index].addressEmail) !== true) {
                values[index].statusID = 0;
              }
            }
            if (
              values[index].currencyID === 0 &&
              values[index].currencyCode !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].thermalPrinterSizeID === 0 &&
              values[index].thermalPrinterSizeName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (values[index].address === "") {
              values[index].statusID = 0;
            }
            if (values[index].city === "") {
              values[index].statusID = 0;
            }
            if (values[index].countryCode === "") {
              values[index].statusID = 0;
            }
          }}
          columns={[
            {
              header: "Mass Upload Status",
              field: "statusID",
              body: (rowData) => {
                if (rowData.statusID === 0) {
                  return <Badge variant="danger">Not Ready To Upload</Badge>;
                } else if (rowData.statusID === 1) {
                  return <Badge variant="success">Ready To Upload</Badge>;
                } else if (rowData.statusID === 2) {
                  return <Badge variant="primary">Successfully Uploaded</Badge>;
                } else if (rowData.statusID === 3) {
                  return (
                    <React.Fragment>
                      <span className="mr-3">
                        <BootstrapTooltip title={rowData.message}>
                          <span className="mr-1">
                            <i className="fas fa-exclamation-triangle kt-font-warning"></i>
                          </span>
                        </BootstrapTooltip>
                        <Badge variant="danger">Unsuccessfully Uploaded</Badge>
                      </span>
                    </React.Fragment>
                  );
                }
              },
              sortable: true,
              filter: true,
            },
            {
              header: "Outlet Name",
              field: "outletName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.outletName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Outlet Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.outletName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.outletName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.outletName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Phone Number",
              field: "addressPhone",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.addressPhone === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Phone Number is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.addressPhone}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.addressPhone !== "" ? (
                      <React.Fragment>
                        {checkRegexPhoneNumber(rowData.addressPhone) ===
                        true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.addressPhone}
                              </span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.addressPhone}
                              </span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Email",
              field: "addressEmail",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.addressEmail === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Email is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.addressEmail}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.addressEmail !== "" ? (
                      <React.Fragment>
                        {checkRegexEmail(rowData.addressEmail) === true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.addressEmail}
                              </span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Email must be valid. e.g. joe@invifo.com">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.addressEmail}
                              </span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Currency",
              field: "currencyID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.currencyID === 0 && rowData.currencyCode !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Currency is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.currencyCode}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.currencyID === 0 &&
                      rowData.currencyCode === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Currency is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.currencyCode}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.currencyID > 0 ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.currencyCode}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: currencyOptions,
            },
            {
              header: "Thermal Printer Size",
              field: "thermalPrinterSizeID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.thermalPrinterSizeID === 0 &&
                    rowData.thermalPrinterSizeName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Thermal Printer Size is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.thermalPrinterSizeName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : rowData.thermalPrinterSizeID === 0 &&
                      rowData.thermalPrinterSizeName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Thermal Printer Size is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.thermalPrinterSizeName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : rowData.thermalPrinterSizeID > 0 ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.thermalPrinterSizeName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: thermalPrinterSizeOptions,
            },
            {
              header: "Address",
              field: "address",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.address === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Address is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.address}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.address !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.address}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "City",
              field: "city",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.city === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="City is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.city}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.city !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.city}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Province / State",
              field: "province",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.province}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Country",
              field: "countryCode",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.countryCode === "" &&
                    rowData.countryName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Country is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.countryCode === "" &&
                      rowData.countryName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Country is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.countryCode !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: countryOptions,
            },
            {
              header: "Postal Code",
              field: "postalCode",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.postalCode}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
          ]}
        />
      ) : (
        <Illustration
          imageSource="INVIFO Setup.png"
          description="Good Start! You're ready for Mass Upload!"
          guidance="Hint: upload master data based on template provided"
          descriptionLeftIcon="fas fa-info-circle kt-font-success"
        ></Illustration>
      )}
    </>
  );
  function setMasterData(currencies = [], countries = []) {
    let currencyOptionsTmp = [];
    let thermalPrinterSizeOptionsTmp = [];
    let countryOptionsTmp = [];
    if (typeof currencies !== "undefined") {
      currencies.forEach((currency) => {
        currencyOptionsTmp.push({
          value: currency.ID,
          label: currency.currencyCode,
        });
      });
    }

    thermalPrinterSizeOptionsTmp.push({
      value: 58,
      label: "58mm",
    });
    thermalPrinterSizeOptionsTmp.push({
      value: 80,
      label: "80mm",
    });

    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }

    setCurrencyOptions(currencyOptionsTmp);
    setThermalPrinterSizeOptions(thermalPrinterSizeOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }
}

export default ConfirmUploadedOutlets;
